import { __rest, __assign } from 'tslib';
import MuiMenu from '@mui/material/Menu';
import React from 'react';
import { usePopoverPlacement } from '../Popover/index.js';
import '@mui/material/Popover';
import '@mui/material/styles';
import '../../getPopoverPlacement-19aa073e.js';

var PlacementMenu = React.forwardRef(function PlacementMenu(_a, ref) {
    var placement = _a.placement, restProps = __rest(_a, ["placement"]);
    var popoverPlacement = usePopoverPlacement(placement);
    return React.createElement(MuiMenu, __assign({}, restProps, popoverPlacement, { ref: ref }));
});
var Menu = React.forwardRef(function Menu(_a, ref) {
    var placement = _a.placement, restProps = __rest(_a, ["placement"]);
    if (placement) {
        return React.createElement(PlacementMenu, __assign({}, restProps, { placement: placement, ref: ref }));
    }
    return React.createElement(MuiMenu, __assign({}, restProps, { ref: ref }));
});

export { Menu as default };
